<template>
	    <!--弹出层-->
    <div class="mask update-room" >
        <div class="e-modal small">
            <div class="e-modal-title">预定核销 <i class="e-modal-close" @click="close"></i></div>
            <div class="e-modal-body-one">
                <div class="filter-box-one">
                        <div class="filter-item">
                            <label class="item-title">入住时间:</label>
                            <input class="item-input" type="text"  @click="calendar.show=true"  v-model="CheckIn" />
                            <Calendar style="margin-left:104px"  v-if="calendar.show" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" :begin="calendar.begin"  @select="calendar.select"></Calendar>

                        </div>
                    </div>
                    <div class="filter-box-one">
                        <div class="filter-item">
                            <label class="item-title">离店时间:</label>
                            <input class="item-input" type="text" id="dateEnd22"  @click="calendar2.show=true"  v-model="CheckOut"/>
                            <calendar style="margin-left:104px"  v-if="calendar2.show" :zero="calendar2.zero" :lunar="calendar2.lunar" :value="calendar2.value" :begin="calendar2.begin"  @select="calendar2.select"></calendar>

                        </div>
                    </div>
                    <div class="filter-box-one">
                        <div class="filter-item">
                            <label class="item-title">姓:</label>
                            <input class="item-input" type="text"  v-model="FirstName" />
                        </div>
                    </div>
                    <div class="filter-box-one">
                        <div class="filter-item">
                            <label class="item-title">名:</label>
                            <input class="item-input" type="text" v-model="LastName" />
                        </div>
                    </div>
            </div>
            <div class="e-modal-footer">
                <div class="long-btn save-btn" @click="create">保存</div>
                <div class="long-btn cancel-btn" @click="close">取消</div>
            </div>
        </div>
    </div>
</template>
<script>
	import Calendar from './../../common/calendar/calendar.vue'//日期选择器
	export default{
		name:'veri-check',
		components:{
			Calendar
		},
		props:{
	    	cData:{
	    		type:Object,
	    		default:function(){
	    			return{}
	    		}
	    	}
	    },
	    data(){
	    	return{
	    		calendar:{
		            display:"",
		            show:false,
		            zero:true,
		            begin:this.getDate(1).split('-'),
		            value:this.getDate(1).split('-'),
		            lunar:false, //显示农历
		            select:(value)=>{
		            	
		                if(!value){
		                    this.calendar.show=false;
		                    return;
		                }
		                this.CheckIn=value.join('-');
		               
		                this.calendar.value=value;
		                this.calendar2.begin=value;
					
						this.calendar2.value=value;
		                this.DateTo='';
					
		               
		              
		                this.calendar2.show=true;

		                this.calendar.show=false;
		                var end=document.getElementById('dateEnd22');
		            	end.focus();
		            }
		        },
		        calendar2:{
		            display:"",
		            show:false,
		            zero:true,
		            // begin:'', //默认日期
		            value:this.getDate(2).split('-'),
		            lunar:false, //显示农历
		            select:(value)=>{
		            	
		                if(!value){
		                    this.calendar2.show=false;
		                    return;
		                }
		                this.CheckOut=value.join('-');
		               
		                this.calendar2.value=value;
		                this.calendar2.show=false;
		                // this.calendar.display=value.join("-");
		            }
		        },
		        userInfo:JSON.parse(this.dao.get('res')),
		        CheckIn:this.getDate(1),
		        CheckOut:this.getDate(2),
		        FirstName:'',
		        LastName:'',
	    	}
	    },
	    methods:{
	    	close(){
	    		this.$emit('close')
	    	},
	    	create(){
            
                var that=this;
           		if(!that.FirstName){
           			that.error({ title: '提示', content: '请输入姓' });
           			return;
           		}      
           		if(!that.LastName){
           			that.error({ title: '提示', content: '请输入名' });
           			return;
           		}
                var params={
                  CheckIn: that.CheckIn,
                  CheckOut: that.CheckOut,
                  FirstName: that.FirstName,
                  LastName: that.LastName,
                  QGid: that.cData.QGId,
                  Operator: that.userInfo.userName,
                  OperatorName: that.userInfo.SupplierName,
                  SubCode: that.cData.SubCode,
            
                }
                that.postRequest({
                    url: that.Api.createLimit,
                    params: params
                }).then(res => {
                 
                    if(res&&res.IsSuccess){
                    	that.error({ title: '提示', content: res.Msg });
						that.$emit('ok');
                    }else{
                    	that.error({ title: '提示', content: res.Msg });
                    }
                 
                });

            },
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/veri/check.vue